import React from 'react';

const RedirectContext = React.createContext();
export const RedirectProvider = RedirectContext.Provider;
export const RedirectConsumer = RedirectContext.Consumer;
export default RedirectContext;
